const initialState = {
  reportTypes: [],
  selectedReportType: "",
  generatedReports: [],
  totalReports: 0,
};
export default initialState;
